import { useLang } from "../../contexts/LanguageContext";

export default function PageHero({ title, subtitle, image }) {
  const { t } = useLang();
  return (
    <section className="relative bg-[#0F2040] text-white py-32 md:py-44 overflow-hidden">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F2040]/95 via-[#0F2040]/80 to-[#0F2040]/60" />
        </>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cecit-gold mb-5">
          <span className="editorial-rule mr-3 align-middle"></span>
          CECIT · {t("hero.since")}
        </p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl mb-6">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-white/80 leading-relaxed md:whitespace-nowrap" data-testid="page-hero-subtitle">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
